import React from "react";
import {Button, Chip, Divider, Typography} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {CardHeader} from "components/picking/components/card.header";
import {AddCircleOutlineRounded} from "@material-ui/icons";

/**
 * Muestra el resumen de todo lo escaneado en el ingreso de una orden de compra.
 * Lista los artículos con lo escaneado vs. lo pedido, marcando los que no estaban
 * en la OC original y los que tienen una cantidad distinta a la pedida.
 */
export function ResumenView(props) {
    const {idOrdenCompra, articulos, onVolver, onConfirm} = props;

    // Todo lo efectivamente escaneado.
    const escaneados = articulos.filter(articulo => (parseInt(articulo.scanned) || 0) > 0);

    return (
        <div style={{height: window.innerHeight - 47, overflowY: 'auto'}}>
            <CardHeader
                textLeft={<>Resumen OC: <b>{idOrdenCompra}</b></>}
                textRight={<><b>{escaneados.length}</b> artículos</>}
            />

            {escaneados.length <= 0 && (
                <Typography variant="body1" align={"center"} className={"mt-4"}>No se escaneó ningún artículo.</Typography>
            )}

            {escaneados.map((articulo, index) => {
                const scanned = parseInt(articulo.scanned) || 0;
                const cantidad = parseFloat(articulo.cantidad) || 0;
                const enOrden = articulo.enOrden !== false;
                const cantidadDistinta = enOrden && scanned !== cantidad;

                return (
                    <React.Fragment key={index}>
                        <Card className={'m-0 p-0'} elevation={0} style={{borderRadius: 0}}>
                            <CardContent style={{padding: '12px'}}>
                                <Box className={'d-flex justify-content-between align-items-center'}>
                                    <Typography color="textPrimary" component={"span"}>
                                        {articulo.id}
                                        {!enOrden && (
                                            <Chip
                                                size={"small"}
                                                color={"secondary"}
                                                icon={<AddCircleOutlineRounded/>}
                                                label={"Fuera de OC"}
                                                className={'ml-2'}
                                            />
                                        )}
                                    </Typography>
                                    <Typography
                                        component={"span"}
                                        variant={"body2"}
                                        color={cantidadDistinta ? "error" : "primary"}
                                        align={"right"}
                                    >
                                        Escaneados <big>{scanned}</big>
                                        {enOrden && <b> de <big>{cantidad}</big></b>}
                                    </Typography>
                                </Box>
                                <Typography variant="body2" color={"textSecondary"} component={"div"}>
                                    {articulo.detalle}
                                </Typography>
                                {cantidadDistinta && (
                                    <Typography variant="caption" color={"error"} component={"div"}>
                                        La cantidad escaneada no coincide con la pedida.
                                    </Typography>
                                )}
                            </CardContent>
                        </Card>
                        <Divider/>
                    </React.Fragment>
                );
            })}

            <Box className={'mt-3'}>
                <Button
                    size={"medium"}
                    variant={"contained"}
                    className={'mt-2 mb-2'}
                    color={"primary"}
                    style={{width: '90%', height: '3.5rem', margin: '0 5%'}}
                    disabled={escaneados.length <= 0}
                    onClick={() => onConfirm(escaneados)}
                >
                    Confirmar Ingreso
                </Button>
                <Button
                    size={"medium"}
                    variant={"contained"}
                    className={'mt-2 mb-2'}
                    style={{width: '90%', height: '3.5rem', margin: '0 5%'}}
                    onClick={onVolver}
                >
                    Volver a Escanear
                </Button>
            </Box>
        </div>
    );
}
